import React from 'react'
import './index.css'

const AcountPage = () =>
  <section className='account-page-container'>
    <h1 className='account-page-title'>User Account settings</h1>
    <p className='account-page-shoutout'>This section of the app is to be developed at a later stage.</p>
  </section>

export default AcountPage



// WEBPACK FOOTER //
// ./src/pages/Account/index.jsx